<template>
  <div>
    <header>
      <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/materialize/1.0.0/css/materialize.min.css">

      <!-- Include CSS do MDB -->
      <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/mdb-ui-kit/6.4.1/mdb.min.css">

      <!-- Include CSS do DataTables com MDB -->
      <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/mdb-ui-kit/6.4.1/mdb.datatables.min.css">

      <link rel="stylesheet" href="node_modules/datatables.net-dt/css/dataTables.dataTables.min.css">

      <h1></h1>
    </header>

    <div class="title-container">
      <h3 class="title">LOG WS</h3>
    </div>

    <div class="container container-bkg">
      <!-- <h3 class="title">LOG WS</h3> -->
      <!-- <hr> -->
      <div class="row m-1">
        <div class="col">
          <form id="formConsulta" @submit="pesquisar()">
            <fieldset>
              <legend class="legend-border"><i class="fas fa-search"></i>Filtro</legend>

              <hr class="mt-0"/>

              <div class="row">
                <div class="col-12 col-sm-12 col-md-3">
                  <select class="form-select" @change="mudarArea()" id="select-area">
                    <option value="" selected>Área:</option>
                    <option value="gestao-parceiro">Gestão Parceiro</option>
                    <option value="automovel">Automóvel</option>
                  </select>
                </div>
                <div class="col-12 col-sm-12 col-md-3">
                  <select class="form-select" v-model="selectedServico" @change="mudarServico()" id="select-servico">
                    <option value="" selected>Serviço:</option>
                    <option
                      v-for="servico in servicos"
                      :key="servico.servico"
                      :value="servico.servico"
                    >
                      {{ servico.servico }}
                    </option>
                  </select>
                </div>
                <div class="col-12 col-sm-12 col-md-3">
                  <select class="form-select" @change="mudarBusca()" id="select-busca">
                    <option value="" selected>Tipo Busca:</option>
                    <option value="id">Busca por Id</option>
                    <option value="filtros">Busca por Filtros</option>
                  </select>
                </div>
                <div class="col-12 col-sm-12 col-md-3">
                  <div id="id-log-div" class="form-outline">
                    <input type="text" class="form-control" id="id-log" required oninvalid="this.setCustomValidity('Id Log é obrigatório!')" oninput="this.setCustomValidity('')"/>
                    <label class="form-label" for="">Id Log:</label>
                    <FormNotch />
                  </div>
                </div>
              </div>
              <div class="row mt-4">
                <div class="col-12 col-sm-12 col-md-3 mt-2">
                  <div id="campo1-form" class="form-outline">
                    <input value-type="format" lang="pt-br" placeholder="dd/mm/yyyy hh:mm:ss" class="form-control active" id="campo1" required oninvalid="this.setCustomValidity('Data de início é obrigatória!')" oninput="this.setCustomValidity('')" />
                    <label class="form-label" for="">Data Início:</label>
                    <FormNotch />
                  </div>
                </div>
                <div class="col-12 col-sm-12 col-md-3 mt-2">
                  <div id="campo2-form" class="form-outline">
                    <input value-type="format" lang="pt-br" placeholder="dd/mm/yyyy hh:mm:ss" class="form-control active" id="campo2" required oninvalid="this.setCustomValidity('Data fim é obrigatória!')" oninput="this.setCustomValidity('')"/>
                    <label class="form-label" for="">Data Fim:</label>
                    <FormNotch />
                  </div>
                </div>

                <div model="selectedCampos" class="col-12 col-sm-12 col-md-3 mt-2"
                v-for="campo in campos"
                :key="campo.nome"
                :value="campo.nome"
                >
                  <div class="form-outline">
                    <input :id="campo.nome" :type="campo.formato" class="form-control"/>
                    <label class="form-label" for="">{{ campo.nome }}:</label>
                    <FormNotch />
                  </div>
                </div>

              </div>
            </fieldset>

            <hr class="mb-4"/>

            <div class="d-flex justify-content-end">
              <button class="btn btn-sm btn-primary waves-effect waves-light search-button" type="submit">
                <i class="fas fa-search me-1"></i>
                <span class="search-span">Pesquisar</span>
              </button>
            </div>

            <hr class="mt-4" />

          </form>
        </div>
      </div>
    
      <div v-if="showList" class="lista-div" aria-hidden="true">

      <h3 class="title m-3">Lista</h3>
      <hr class="m-3">
      <div class="container mt-4">
        <table id="dataTable" class="table table-striped">
            <thead>
                <tr>
                    <th>Id</th>
                    <th>Inicio</th>
                    <th>Fim</th>
                    <th>Erro</th>
                    <th>Entrada</th>
                    <th>Saida</th>
                </tr>
            </thead>
            <tbody>
                <tr model="selectedListas"
                v-for="lista in this.listas"
                :key="lista.id"
                :value="lista.id"
                >
                  <td>{{ lista.id }}</td>
                  <td>{{ lista.dataInicio }}</td>
                  <td>{{ lista.dataFim }}</td>
                  <td>
                    <div>
                      <a class="btn-acoes" @click="openModal(String(lista.id), 'erro')"><i class="fas fa-search"></i></a>
                    </div>
                  </td>
                  <td>
                    <div>
                      <a class="btn-acoes" @click="openModal(String(lista.id), 'entrada')"><i class="fas fa-search"></i></a>
                    </div>
                  </td>
                  <td>
                    <div>
                      <a class="btn-acoes" @click="openModal(String(lista.id), 'saida')"><i class="fas fa-search"></i></a>
                    </div>
                  </td>
                </tr>
            </tbody>
        </table>
    </div>

    <!-- O Modal -->
    <div v-if="showModal" class="modal fade" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Dados da Lista</h5>
            <button type="button" class="btn-close" data-mdb-dismiss="modal" @click="closeModal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <label class="form-label" for="textAreaExample">{{tipoBusca}}:</label>
            <textarea id="textAreaExample" rows="4" style="height: 207px;" placeholder="">{{logTextAreaValue}}</textarea>
          </div>
          <div class="modal-footer" style="background-color: transparent !important;">
            <button type="button" class="btn btn-danger" data-mdb-dismiss="modal" @click="closeModal">Fechar</button>
          </div>
        </div>
      </div> 
    </div>
    
    </div>
    </div> 
    
    <div class="loader" v-if="showModal">
      <div>
        <div class="spinner-border"></div>
      </div>
    </div>    
  </div>
</template>
 
 
<!-- Include JavaScript do DataTables com MDB -->
<script src="https://cdnjs.cloudflare.com/ajax/libs/mdb-ui-kit/6.4.1/mdb.datatables.min.js"></script>


<script>
import axios from 'axios';
import * as alertUtils from '@/utils/alert';
import * as loaderUtils from '@/utils/loader';
import FormNotch from './FormNotch.vue';

import $ from 'jquery'; // Importando jQuery
import 'mdb-ui-kit'; // Importando o JavaScript do MDB
import 'datatables.net'; // Importando DataTables

export default {
  data() {
    return {
      campos: [],
      servicos: [],
      selectedServico: "",
      selectedCampos: "",
      selectedListas: "",
      idServico: "",
      tipoBusca: "",
      showModal: false,
      showList: false,
      listas: [],
      logTextAreaValue: [],
      dadosModal: {}
    };
  },
  components: {
    FormNotch
  },
  methods: {
    async openModal(valorIdLog, tipoBusca) {
      this.showModal = true;

      function capitalizeCharAtIndex(str, index) {
        return str.slice(0, index) + str.charAt(index).toUpperCase() + str.slice(index + 1);
      }

      const indexToCapitalize = 0; // Índice do caractere a ser transformado
      this.tipoBusca = capitalizeCharAtIndex(tipoBusca, indexToCapitalize);

      let urlApi;
      let method;
      let jsonRequest;
      let requestOptions;
      const valorBusca = $("#select-busca").val();
      const valorDataInicial = $('#campo1').val();
      const valorDataFinal = $('#campo2').val();

      switch (valorBusca) {
        case 'filtros':
          urlApi = '/massificados/corporativo/gerenciador-parceiros/rest/log-ws/consultar/' + valorIdLog;
          method = 'GET';

          requestOptions = {
            method: method
          };
        break;
        case 'id':
          urlApi = '/massificados/corporativo/gerenciador-parceiros/rest/log-ws/consultar/' + valorIdLog;
          method = 'GET';

          requestOptions = {
            method: method
          };
        break;
      }

      try {
        fetch(urlApi, requestOptions)
          .then(async (response) => {
            if (response.ok) {
              return response.json();
            } else {
              throw new Error('Fechar');
            }
          })
          .then(async (data) => {
            switch (tipoBusca) {
              case 'erro':
                this.logTextAreaValue = data.erro;
              break;
              case 'entrada':
                this.logTextAreaValue = data.entrada;
              break;
              case 'saida':
                this.logTextAreaValue = data.saida;
              break;
            }
            if(await this.logTextAreaValue.length < 1){
              await alertUtils.alertError('Nenhum log encontrado!', 'Fechar');
            } else {
              const modalElement = await document.querySelector('.modal');
              const modalInstance = await new mdb.Modal(modalElement);
              await modalInstance.show();
            }
          })
          .catch((error) => {
            alertUtils.alertError('Não encontramos nenhum resultado!', 'Fechar');
          }).finally(() => 'loaderUtils.removeLoader()');
         
      } catch (error) {
        alertUtils.alertError('Erro ao realizar busca:'+ error);
      }
    },
    closeModal() {
      this.showModal = false;
      const modalElement = document.querySelector('.modal');
      const modalInstance = new mdb.Modal(modalElement);
      modalInstance.hide();
    },
    async pesquisar() {
      let urlApi;
      let method;
      let jsonRequest;
      let requestOptions;
      const valorIdLog = $("#id-log").val();
      const valorBusca = $("#select-busca").val();
      const valorDataInicial = $('#campo1').val();
      const valorDataFinal = $('#campo2').val();

      switch (valorBusca) {
        case 'filtros':
          urlApi = '/massificados/corporativo/gerenciador-parceiros/rest/log-ws/consultar/';
          method = 'POST';
         
          let camposArray = new Array();

          this.campos.forEach(element => {
            const nomeCampo = element.nome;
            const valorCampo = $(`#${element.nome}`).val();
            if(valorCampo.length >= 1) camposArray.push({nomeCampo, valorCampo})
          });

          // Função para transformar os dados
          function transformarDados(dados) {
              return dados.reduce((acc, item) => {
                  acc[item.nomeCampo] = item.valorCampo;
                  return acc;
              }, {});
          }

          // Usar a função e exibir o resultado
          let objectCampos = transformarDados(camposArray);

          if(JSON.stringify(objectCampos) === '{}'){
            // loaderUtils.removeLoader();
            return alertUtils.alertError('É obrigatório o preenchimento de um campo!', 'Fechar');
          }

          jsonRequest = {
            "idServico": String(this.idServico),
            "dataInicio": String(valorDataInicial),
            "dataFim": String(valorDataFinal),
            "pesquisa": objectCampos
          };

          jsonRequest = JSON.stringify(jsonRequest);

          requestOptions = {
            method: method,
            body: jsonRequest,
            headers:  {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
            }
          };
        break;
        case 'id':
          urlApi = '/massificados/corporativo/gerenciador-parceiros/rest/log-ws/consultar/' + valorIdLog;
          method = 'GET';

          requestOptions = {
            method: method
          };
        break;
      }

      try {
        fetch(urlApi, requestOptions)
          .then(async (response) => {
            if (response.ok) {
              // alertUtils.alertSuccess("Busca feita com sucesso!");
              return response.json();
            } else {
              throw new Error('Fechar');
            }
          })
          .then((data) => {            
            this.showList = true;

            if(valorBusca === "id") {
              this.listas = [data];
            } else {
              this.listas = data;
            }
            
            // Inicialize o DataTable após o componente ser montado
            $(document).ready(function() {
              const table = $('#dataTable');

              // Verifica se o DataTable já está inicializado
              if ($.fn.dataTable.isDataTable(table)) {
                  // Destrói a instância anterior do DataTable
                  // table.DataTable().clear().destroy();
              }

              // Inicializa a tabela apenas se ela ainda não foi inicializada
              if (!$.fn.dataTable.isDataTable(table)) {
                $('#dataTable').DataTable({
                  pageLength: 4, // Número de itens por página
                  dom: 'Bfrtip', // Para incluir botões de exportação
                  pagination: true, // Habilita a paginação
                  dom: 'Bfrtip',
                  language: {
                      emptyTable: "Nenhum dado disponível na tabela.",
                      info: "Total: _TOTAL_ ",
                      infoEmpty: "Mostrando 0 até 0 de 0 entradas",
                      infoFiltered: "(filtrado de _MAX_ entradas no total)",
                      lengthMenu: "Mostrar _MENU_ entradas",
                      loadingRecords: "Carregando...",
                      processing: "Processando...",
                      search: "Buscar:",
                      zeroRecords: "Nenhum registro encontrado",
                      paginate: {
                          // first: "Primeira",
                          // last: "Última",
                          // next: "Próxima",
                          // previous: "Anterior"
                      }
                  }
                  // ...outras opções
                });
              }

              if(valorBusca === "id") {
                this.listas = [data];
              } else {
                this.listas = data;
              }

              $('#dataTable_info').html('Total '+this.listas.length);

              $("#dataTable_info").css("margin-top", "13px");
              $("#dataTable_info").css("margin-bottom", "4px");
            });
          })
          .catch((error) => {
            // loaderUtils.removeLoader();
            console.log(error)
            alertUtils.alertError('Não encontramos nenhum resultado!', 'Fechar');
          }).finally(() => 'loaderUtils.removeLoader()');
         
      } catch (error) {
        console.error('Erro ao realizar busca:', error);
        alertUtils.alertError('Erro ao realizar busca:'+ error);
      }
    },
    buscarServico(area) {
      // loaderUtils.addLoarder();

      const urlApi = '/massificados/corporativo/gerenciador-parceiros/rest/log-ws/listar-servico-log-ws/' + area;
      const requestOptions = {
        method: 'GET'
      };
      // return 1;

      let servicos = new Array;
      
      fetch(urlApi, requestOptions)
        .then((response) => {
          if (response.ok) {
            return response.json();
          } else {
            throw new Error('Erro na solicitação à API');
          }
        })
        .then((data) => {
          data.map((x) => servicos.push(x.servico));
          if(servicos.length < 1){
            alertUtils.alertError('Nenhum Serviço Encontrado!', 'Fechar');
            $('#select-servico').css('display','none');
          } else {
            this.servicos = data;
          }
        })
        .catch((error) => {
          // loaderUtils.removeLoader();
          alertUtils.alertError('Erro na requisição:', error);
        })
        .finally(() =>  '');
    },
    async mudarArea() {
      const valorCampoArea = $("#select-area").val();
      if(valorCampoArea != ''){
        $('#select-servico').css('display','unset');
        
        await this.buscarServico(valorCampoArea);
      } else {
        $('#select-servico').css('display','none');
      }
    },
    async mudarServico() {
      const valorCampoArea = $("#select-servico").val();
      if(valorCampoArea != ''){
        $('#select-busca').css('display','unset');
        this.mudarBusca();
      } else {
        $('#select-busca').css('display','none');
        
        $('#id-log-div').css('display','none');
        $('#campo1-form').css('display','none');
        $('#campo2-form').css('display','none');
        $('#campo3-form').css('display','none');
        $('#campo4-form').css('display','none');

        this.campos = [];
      }
    },
    async carregarDatas() {
      // Cria um objeto de data com a data atual (considerando o fuso horário local)
      const hoje = new Date();

      // Ajusta o horário para 00:00:00 para evitar qualquer impacto de fuso horário
      hoje.setHours(0, 0, 0, 0);

      // Subtrai 30 dias da data
      hoje.setDate(hoje.getDate() - 30);

      // Formata a data no formato desejado
      const dia = String(hoje.getDate()).padStart(2, '0');
      const mes = String(hoje.getMonth() + 1).padStart(2, '0'); // Mes começa do 0, por isso somamos 1
      const ano = hoje.getFullYear();

      // Monta a string no formato DD/MM/YYYY 00:00:00
      const dataInicio = `${dia}/${mes}/${ano} 00:00:00`;

      // Cria um objeto de data com a data e hora atuais
      const hojeFim = new Date();

      // Ajusta para o fuso horário de Brasília (UTC-3)
      const brasiliaOffset = -3; // UTC-3 para o horário de Brasília
      const localOffset = hojeFim.getTimezoneOffset() / 60; // Diferença de horário local do navegador em horas

      // Calcula a diferença e ajusta
      hoje.setHours(hojeFim.getHours() + localOffset + brasiliaOffset);

      // Formata a data no formato desejado
      const diaFim = String(hojeFim.getDate()).padStart(2, '0');
      const mesFim = String(hojeFim.getMonth() + 1).padStart(2, '0'); // Mes começa do 0, por isso somamos 1
      const anoFim = hojeFim.getFullYear();

      // Monta a string no formato DD/MM/YYYY HH:MM:SS
      const dataFim = `${diaFim}/${mesFim}/${anoFim} 23:59:59`;

      $('#campo1').val(dataInicio);
      $('#campo2').val(dataFim);
    },
    async mudarBusca() {
      const valorCampoArea = $("#select-busca").val();
      if(valorCampoArea === 'id'){
        $('#id-log').attr('required', true);
        $('#campo1').removeAttr('required');
        $('#campo2').removeAttr('required');

        $('#id-log-div').css('display','unset');
        $('#campo1-form').css('display','none');
        $('#campo2-form').css('display','none');
        $('#campo3-form').css('display','none');
        $('#campo4-form').css('display','none');

        this.campos = [];
      } else if (valorCampoArea === 'filtros'){
        $('#id-log').removeAttr('required');

        $('#campo1-form').css('display','unset');
        $('#campo2-form').css('display','unset');
        $('#campo3-form').css('display','unset');
        $('#campo4-form').css('display','unset');
        $('#id-log-div').css('display','none');

        const valorCampoServico = $("#select-servico").val();
        
        this.servicos.forEach(element => {
          if(valorCampoServico === element.servico){
            this.campos = element.campos;
            this.idServico = element.id;
          }
        });
        
        const listaCampos = [];
        for (const key in this.campos) {
            const formatoCampo = this.campos[key] === 'String' ? 'text': 'number';

            listaCampos.push(
              {
                "nome": key,
                "formato": formatoCampo
              }
            );
        }

        this.campos = listaCampos;
      } else if (valorCampoArea === ''){
        $('#id-log-div').css('display','none');
        $('#campo1-form').css('display','none');
        $('#campo2-form').css('display','none');
        $('#campo3-form').css('display','none');
        $('#campo4-form').css('display','none');

        this.campos = [];
      }
    }
  },
  mounted() {
    $('#select-servico').css('display','none');
    $('#select-busca').css('display','none');
    $('#id-log-div').css('display','none');

    $('#campo1-form').css('display','none');
    $('#campo2-form').css('display','none');
    $('#campo3-form').css('display','none');
    $('#campo4-form').css('display','none');

    this.carregarDatas();

    document.getElementById('campo1').addEventListener('input', function (e) {
      let value = e.target.value.replace(/\D/g, ''); // Remove tudo que não é número

      if (value.length > 14) {
          value = value.slice(0, 14); // Limita o comprimento a 14 números
      }

      let formattedValue = '';
      if (value.length > 6) {
          formattedValue += value.slice(0, 2) + '/';
          value = value.slice(2);
          formattedValue += value.slice(0, 2) + '/';
          value = value.slice(2);
          formattedValue += value.slice(0, 4) + ' ';
          value = value.slice(4);
      } else if (value.length > 2) {
          formattedValue += value.slice(0, 2) + '/';
          value = value.slice(2);
          formattedValue += value.slice(0, 2) + '/';
          value = value.slice(2);
      }

      if (value.length > 2) {
          formattedValue += value.slice(0, 2) + ':';
          value = value.slice(2);
      }

      if (value.length > 2) {
          formattedValue += value.slice(0, 2) + ':';
          value = value.slice(2);
      }

      if (value.length > 0) {
          formattedValue += value.slice(0, 2); // Adiciona os segundos
          value = value.slice(2);
      }

      e.target.value = formattedValue;
    });

    document.getElementById('campo2').addEventListener('input', function (e) {
      let value = e.target.value.replace(/\D/g, ''); // Remove tudo que não é número

      if (value.length > 14) {
          value = value.slice(0, 14); // Limita o comprimento a 14 números
      }

      let formattedValue = '';
      if (value.length > 6) {
          formattedValue += value.slice(0, 2) + '/';
          value = value.slice(2);
          formattedValue += value.slice(0, 2) + '/';
          value = value.slice(2);
          formattedValue += value.slice(0, 4) + ' ';
          value = value.slice(4);
      } else if (value.length > 2) {
          formattedValue += value.slice(0, 2) + '/';
          value = value.slice(2);
          formattedValue += value.slice(0, 2) + '/';
          value = value.slice(2);
      }

      if (value.length > 2) {
          formattedValue += value.slice(0, 2) + ':';
          value = value.slice(2);
      }

      if (value.length > 2) {
          formattedValue += value.slice(0, 2) + ':';
          value = value.slice(2);
      }

      if (value.length > 0) {
          formattedValue += value.slice(0, 2); // Adiciona os segundos
          value = value.slice(2);
      }

      e.target.value = formattedValue;
    });
  },
}
</script>

<style>
.title-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 12vh;
}
nav {
  margin-top: -2%;
  background-color: transparent !important;
  padding: 0px 0px 0px 0px;
  width: 16%;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0), 0 3px 1px -2px rgba(0, 0, 0, 0), 0 1px 5px 0 rgba(0, 0, 0, 0) !important;
  margin-left: 41%;
}
.btn-acoes {
  margin-top: -13px !important;
}
.dt-search {
  display: none !important;
}
.dt-input {
  width: 9rem !important;
  height: 15px !important;
}
div.dt-paging nav {
  height: 36px !important;
  width: -webkit-fill-available !important;
}
nav, nav .nav-wrapper i, nav a.sidenav-trigger, nav a.sidenav-trigger i {
  line-height: 21px !important;
}
.custom-modal .modal-content {
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
}
.modal-backdrop {
  background-color: rgba(0, 0, 0, 0.5) !important;
}
.modal-content {
  background-color: #fff; /* Cor de fundo do modal */
  padding: 20px;
  border-radius: 8px;
}
.modal {
  display: block;
  max-height: 100rem !important;
  background: transparent !important;
}
.btn-danger {
  background: linear-gradient(254deg, #23c5ae 0%, #19a38f 100%) !important;
}
.dt-paging-button.current {
  background: #2FC8B2 !important;
  color: white !important;
}
input.form-control {
  padding-left: 10px !important;
  box-sizing: border-box !important;         /* Ajusta o box model para incluir padding e borda */
  border: 1px solid #ccc !important;         /* Borda */
  width: 100% !important;                    /* Largura total, evita vazamento */
}

/* Para navegadores baseados em Webkit (Chrome, Safari, Edge, etc.) */
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;  /* Remove as setas */
  margin: 0;
}

/* Para Firefox */
input[type="number"] {
  -moz-appearance: textfield; /* Remove as setas no Firefox */
}

.search-span {
  padding: 15px 10px 20px;
}
.fa-search.me-1 {
  padding-top: 2px;
}
.search-button {
  padding-bottom: 2.6rem !important;
  width: 11rem !important;
}
@import '/massificados/corporativo/gerenciador-parceiros-ui/portal-sistemas/css/style.css';
</style>
